export default __webpack_public_path__ + "static/media/linkedin.14f38c07.svg";